import { gray4, mainColor } from "assets/styleUtils";
import { ButtonModal } from "modal";
import { applyButtonType } from "./InquiryBoxList";
import styles from "./style.module.css";

export function AlertModal({
  onClose,
  limitRequest,
  modalType,
  type,
  handleConfirm,
  blockToApply,
}: {
  onClose: () => void;
  limitRequest: boolean;
  modalType?: applyButtonType;
  type: "wedding" | "etc";
  handleConfirm: () => void;
  blockToApply: boolean;
}) {
  const title =
    limitRequest || blockToApply
      ? "안내사항"
      : modalType === "cancel"
      ? "예약 취소"
      : "예약 변경";
  const sub = getSubText({ limitRequest, modalType, type, blockToApply });
  const oneButton = {
    color: gray4,
    text: limitRequest || blockToApply ? "뒤로가기" : "아니요",
    onClick: onClose,
  };

  return (
    <>
      <div className={styles.overlay} onClick={onClose}></div>
      <div
        className={styles.buttonmodalContainer}
        onClick={(e) => e.stopPropagation()}
      >
        <ButtonModal
          title={title}
          sub={sub}
          oneButton={oneButton}
          {...(!limitRequest &&
            !blockToApply && {
              twoRightButton: {
                color: mainColor,
                text: "네",
                onClick: handleConfirm,
              },
            })}
        />
      </div>
    </>
  );
}

function getSubText({
  limitRequest,
  modalType,
  type,
  blockToApply,
}: {
  limitRequest: boolean;
  modalType?: applyButtonType;
  type: "wedding" | "etc";
  blockToApply: boolean;
}) {
  if (type === "wedding" && blockToApply) {
    return `∙ 예약 취소 및 변경은 상담 확정 일자로부터 
    3일 전까지만 가능하며, 2일 전부터는 
    예약 취소 및 변경이 불가합니다.

∙상담 확정 일자에 방문이 어려운 경우,
해당 웨딩홀에 직접 연락하여 취소 또는 
일정 변경 부탁 드립니다.
      
∙웨딩홀에 연락 없이 당일 노쇼 시,
메이크마이웨딩 예약 센터 패널티가 부여되어
웨딩홀을 포함한 모든 제휴 업체 예약이 불가하니 방문 2일 전 일정 변동이 있을 경우, 
꼭 해당 웨딩홀에 연락하여 취소 및 변경 부탁 드립니다.`;
  }
  if (type === "etc" && blockToApply) {
    return `∙ 예약 취소 및 변경은 방문일로부터 3일 전까지만 가능하시며, 방문일이 2일 이내이신 경우 업체에 직접 연락하셔서 취소 또는 변경 부탁드립니다.

    ∙ 업체에 연락 없이 당일 노쇼 하셨을 경우 메이크마이웨딩 예약센터(웨딩홀 및 전체 제휴업체)이용에 제한이 생길 수 있으며 이 외 이벤트 참여 불가 등의 패널티가 부여되오니 업체에 꼭 연락하셔서 취소 부탁드리겠습니다.

    ∙ 업체 자체적으로 예약 취소 및 변경이 불가할 수 있으며, 메이크마이웨딩 패널티와 별개로 업체 내부 규정에 따른 패널티가 부여될 수 있는 점 참고 부탁드립니다.`;
  }
  if (limitRequest) {
    return `예약 변경&취소 가능 회수는 웨딩홀별 총 1회로 추가 변경 및 취소는 어렵습니다.
    웨딩홀에 직접 연락하여 일정 변경&방문 취소 부탁 드립니다. 감사합니다.`;
  }

  if (modalType === "cancel") {
    return type === "wedding"
      ? `예약취소시 알림톡이 발송됩니다. 
      [웨딩홀 예약취소] 버튼을 눌러주셔야 접수가 완료됩니다.`
      : `예약취소시 알림톡이 발송됩니다. 
      [기타 예약취소] 버튼을 눌러주셔야 접수가 완료됩니다.`;
  }

  return type === "wedding"
    ? `예약변경시 알림톡이 발송됩니다. 
    [웨딩홀 예약변경] 버튼을 눌러주셔야 접수가 완료됩니다.`
    : `예약변경시 알림톡이 발송됩니다. 
    [기타 예약변경] 버튼을 눌러주셔야 접수가 완료됩니다.`;
}
